module.exports = __webpack_public_path__ + "static/media/arrow-left-black.9c14ebcf.svg";